import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty2 from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import FormLabel from "../FormLabel";
import { FakeInput, Input, InputContainer } from "../InputField";
import { SelectContainer } from "../Select";
import FormFeedback from "../FormFeedback";
import { SIZE_OPTIONS, TOKENS } from "./consts";
import { right, rtlSpacing } from "../utils/rtl";
import getSpacingToken from "../common/getSpacingToken";
import randomID from "../utils/randomID";

var getToken = function getToken(name) {
  return function (_ref) {
    var _TOKENS$height, _TOKENS$heightLine, _tokens;

    var theme = _ref.theme,
        size = _ref.size;
    var tokens = (_tokens = {}, _defineProperty2(_tokens, TOKENS.height, (_TOKENS$height = {}, _defineProperty2(_TOKENS$height, SIZE_OPTIONS.SMALL, theme.orbit.heightInputSmall), _defineProperty2(_TOKENS$height, SIZE_OPTIONS.NORMAL, theme.orbit.heightInputNormal), _TOKENS$height)), _defineProperty2(_tokens, TOKENS.heightLine, (_TOKENS$heightLine = {}, _defineProperty2(_TOKENS$heightLine, SIZE_OPTIONS.SMALL, "16px"), _defineProperty2(_TOKENS$heightLine, SIZE_OPTIONS.NORMAL, "24px"), _TOKENS$heightLine)), _tokens);
    return tokens[name][size];
  };
};

var getFakeGroupMarginTop = function getFakeGroupMarginTop(_ref2) {
  var label = _ref2.label,
      theme = _ref2.theme;
  if (!label) return false;
  return "calc(".concat(theme.orbit.lineHeightTextSmall, " + ").concat(theme.orbit.spaceXXSmall, ")");
};

var FakeGroup = styled(function (_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "InputGroup__FakeGroup",
  componentId: "cyuwoi-0"
})(["width:100%;position:absolute;top:0;left:0;z-index:1;box-sizing:border-box;height:", ";border-radius:", ";box-shadow:", ";box-shadow:", ";box-shadow:", ";background-color:", ";font-size:", ";transition:box-shadow ", " ease-in-out;margin-top:", ";&:hover{box-shadow:inset 0 0 0 ", ";}"], getToken(TOKENS.height), function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "inset 0 0 0 ".concat(theme.orbit.borderWidthInput, " ").concat(theme.orbit.borderColorInput);
}, function (_ref6) {
  var theme = _ref6.theme,
      error = _ref6.error;
  return error && "inset 0 0 0 ".concat(theme.orbit.borderWidthInput, " ").concat(theme.orbit.borderColorInputError);
}, function (_ref7) {
  var theme = _ref7.theme,
      active = _ref7.active;
  return active && "inset 0 0 0 ".concat(theme.orbit.borderWidthInputFocus, " ").concat(theme.orbit.borderColorInputFocus);
}, function (_ref8) {
  var disabled = _ref8.disabled,
      theme = _ref8.theme;
  return disabled ? theme.orbit.backgroundInputDisabled : theme.orbit.backgroundInput;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.orbit.fontSizeInputNormal;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.durationFast;
}, getFakeGroupMarginTop, function (_ref11) {
  var theme = _ref11.theme,
      error = _ref11.error;
  return "".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputErrorHover : theme.orbit.borderColorInputHover);
});
FakeGroup.defaultProps = {
  theme: defaultTheme
};
var StyledChildren = styled.div.withConfig({
  displayName: "InputGroup__StyledChildren",
  componentId: "cyuwoi-1"
})(["display:flex;position:relative;"]);
var StyledChild = styled.div.withConfig({
  displayName: "InputGroup__StyledChild",
  componentId: "cyuwoi-2"
})(["flex:", ";padding:", ";:last-child{padding:0;}"], function (_ref12) {
  var flex = _ref12.flex;
  return flex;
}, function (_ref13) {
  var theme = _ref13.theme;
  return rtlSpacing("0 ".concat(theme.orbit.spaceXSmall, " 0 0"));
});
StyledChild.defaultProps = {
  theme: defaultTheme
};
var StyledInputGroup = styled(function (_ref14) {
  var children = _ref14.children,
      className = _ref14.className,
      dataTest = _ref14.dataTest,
      role = _ref14.role,
      ariaLabelledby = _ref14.ariaLabelledby;
  return React.createElement("div", {
    className: className,
    "data-test": dataTest,
    role: role,
    "aria-labelledby": ariaLabelledby
  }, children);
}).withConfig({
  displayName: "InputGroup__StyledInputGroup",
  componentId: "cyuwoi-3"
})(["display:flex;width:100%;flex-direction:column;position:relative;margin-bottom:", ";", "{", "{box-shadow:none;background-color:transparent;display:none;align-items:center;justify-content:flex-end;}", "{background-color:transparent;> select{box-shadow:none;background-color:transparent;&:focus{box-shadow:none;}}}", ":after,", ":after{content:\" \";position:absolute;top:50%;transform:translateY(-50%);", ":0;height:", ";width:1px;background-color:", ";transition:background-color ", " ease-in-out;display:block;z-index:2;}&:last-child{", ":after,", ":after{content:none;}}}", " ", "{display:", ";}", ":focus ~ ", "{box-shadow:none;}"], getSpacingToken, StyledChild, FakeInput, SelectContainer, InputContainer, SelectContainer, right, getToken(TOKENS.heightLine), function (_ref15) {
  var theme = _ref15.theme,
      error = _ref15.error,
      active = _ref15.active;
  return error && !active ? theme.orbit.borderColorInputError : theme.orbit.borderColorInput;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.orbit.durationFast;
}, InputContainer, SelectContainer, StyledChild, FormLabel, function (_ref17) {
  var label = _ref17.label;
  return label && "none";
}, Input, FakeInput);
StyledInputGroup.defaultProps = {
  theme: defaultTheme
};

var InputGroup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InputGroup, _React$PureComponent);

  function InputGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InputGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InputGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false,
      filled: false
    });

    _defineProperty(_assertThisInitialized(_this), "inputID", randomID("inputGroupID"));

    _defineProperty(_assertThisInitialized(_this), "isFilled", function () {
      return _this.setState({
        filled: !React.Children.map(_this.props.children, function (child) {
          return child.props.value !== undefined && child.props.value !== "";
        }).includes(false)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (ev) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        active: true
      });

      if (onFocus) {
        onFocus(ev);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (ev) {
      var onBlur = _this.props.onBlur;

      _this.isFilled();

      _this.setState({
        active: false
      });

      if (onBlur) {
        onBlur(ev);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (ev) {
      var onChange = _this.props.onChange;

      _this.isFilled();

      if (onChange) {
        onChange(ev);
      }
    });

    return _this;
  }

  _createClass(InputGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isFilled();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.children !== prevProps.children) {
        this.isFilled();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          _this$props$flex = _this$props.flex,
          flex = _this$props$flex === void 0 ? "0 1 auto" : _this$props$flex,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? SIZE_OPTIONS.NORMAL : _this$props$size,
          help = _this$props.help,
          error = _this$props.error,
          dataTest = _this$props.dataTest,
          spaceAfter = _this$props.spaceAfter;
      var _this$state = this.state,
          active = _this$state.active,
          filled = _this$state.filled;
      return React.createElement(StyledInputGroup, {
        label: label,
        error: error,
        active: active,
        size: size,
        dataTest: dataTest,
        spaceAfter: spaceAfter,
        role: "group",
        ariaLabelledby: label && this.inputID
      }, label && React.createElement(FormLabel, {
        filled: filled,
        id: this.inputID
      }, label), React.createElement(StyledChildren, null, React.Children.map(children, function (item, key) {
        // either array, array with one length or string
        // if it's not defined, use the first or string
        var childFlex = Array.isArray(flex) && flex.length !== 1 ? flex[key] || flex[0] : flex;
        return React.createElement(StyledChild, {
          flex: childFlex
        }, React.cloneElement(item, {
          ref: function ref(node) {
            // Call the original ref, if any
            var ref = item.ref;

            if (typeof ref === "function") {
              ref(node);
            } else if (ref !== null) {
              ref.current = node;
            }
          },
          size: size,
          label: undefined,
          help: undefined,
          error: undefined,
          onChange: _this2.handleChange,
          onBlur: _this2.handleBlur,
          onFocus: _this2.handleFocus
        }));
      })), React.createElement(FakeGroup, {
        label: label,
        error: error,
        active: active,
        size: size
      }), !error && help && React.createElement(FormFeedback, {
        type: "help"
      }, help), error && React.createElement(FormFeedback, {
        type: "error"
      }, error));
    }
  }]);

  return InputGroup;
}(React.PureComponent);

export default InputGroup;